import React, { Component, PropTypes } from 'react';
import Modal from 'common/components/Modal';
import shallowCompare from 'react-addons-shallow-compare';
import cx from 'classnames';
import { Dropdown, Form } from 'semantic-ui-react';

class CopyZone extends Component {
  constructor(props) {
    super(props);

    this.state = {
      zoneTemplateId: undefined,
      canSubmit: false,
    };

    this._zoneTemplateChanged = this._zoneTemplateChanged.bind(this);
    this._submit = this._submit.bind(this);
  }

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  _zoneTemplateChanged(evt, { value }) {
    this.setState({
      zoneTemplateId: value,
      canSubmit: true,
    });
  }

  _submit(evt) {
    evt.preventDefault();
    const { zoneTemplateId } = this.state;
    if (zoneTemplateId) {
      this.props.onSubmit(zoneTemplateId);
    }
  }

  render() {
    const { onClose, zoneTemplatesRef } = this.props;
    const { canSubmit, isLoading } = this.state;

    const buttonClass = cx('ui primary button', {
      disabled: !canSubmit,
      loading: isLoading,
    });

    let zoneTemplateOptions = zoneTemplatesRef.map(z => ({
      key: z.id,
      text: `${z.name}`,
      value: z.id,
    }));

    return (
      <Modal isOpened closable onClose={onClose}>
        <div className="header">Récupérer une zone</div>
        <div className="content">
          <form id="zoneForm" className="ui form" onSubmit={this._submit}>
            <Form.Field>
              <label>Zone</label>
              <Dropdown
                onChange={this._zoneTemplateChanged}
                fluid
                selection
                placeholder="Choisir une zone"
                options={zoneTemplateOptions}
              />
            </Form.Field>
          </form>
        </div>
        <div className="actions">
          <button type="submit" form="zoneForm" className={buttonClass}>
            Enregister
          </button>
        </div>
      </Modal>
    );
  }
}

CopyZone.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default CopyZone;



// WEBPACK FOOTER //
// ./src/modules/saas/aast/case-study/components/CopyZone.js